import { render, staticRenderFns } from "./ProcessRequests.vue?vue&type=template&id=2b1da8ea"
import script from "./ProcessRequests.vue?vue&type=script&lang=js"
export * from "./ProcessRequests.vue?vue&type=script&lang=js"
import style0 from "./ProcessRequests.vue?vue&type=style&index=0&id=2b1da8ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports